import { render } from "./ProductsListComponent.vue?vue&type=template&id=c6f7b55a"
import script from "./ProductsListComponent.vue?vue&type=script&lang=js"
export * from "./ProductsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__